module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.cc3cf0bd.woff2";